import { styled } from "@mui/material";

export const StyledUl = styled("ul")({
  paddingLeft: "20px", // Removes the default indentation
});
